import * as devisConf from '@/configuration/devisConf';
import { CATEGORIE_FORFAIT_AUDIT } from '@/configuration/configPanneau';

function transformDate(date) {
  if (!date) return date;
  const dateParts = date.split('/');
  return dateParts.reverse().join('-');
}

function getEtatQuery(payload) {
  let etat = [devisConf.ETAT_BROUILLON, devisConf.ETAT_ENREGISTRE]
  if (payload.query.afficherRecomCommande) {
    etat.push(devisConf.ETAT_COMMANDE, devisConf.ETAT_COMMANDE_PARTIELLEMENT);
  }
  if (payload.query.archive) {
    etat = [devisConf.ETAT_SANSSUITE];
  }
  return etat;
}

export function addOrRemplacePanneau(recommandation, panneau) {
  const field = panneau.estPanneauSousContrat ? 'panneauxSousContrat' : 'panneaux';
  const data = recommandation[field];
  const index = data.findIndex(el => el.guid === panneau.guid);
  if (index !== -1) data.splice(index, 1, panneau);
  else data.push(panneau);
  return { data, field };
}

export function removePanneau(recommandation, panneau) {
  const field = panneau.estPanneauSousContrat ? 'panneauxSousContrat' : 'panneaux';
  const data = recommandation[field];
  const index = data.findIndex(el => el.guid === panneau.guid);
  if (index === -1) return null;
  data[index].actif = !data[index].actif;
  return { data, field };
}

export function panneauToMarker(panneau) {
  if (!panneau || panneau.categorie.libelle === CATEGORIE_FORFAIT_AUDIT) return null;
  return {
    guid: panneau.guid,
    adresse1: panneau.adresse.adresse1 ? panneau.adresse.adresse1 : null,
    coordonnees: panneau.adresse.coordonnees ? panneau.adresse.coordonnees : null,
    streetView: panneau.streetView ? panneau.streetView : false,
    icon: panneau.icon ? panneau.icon : null,
  };
}

export function transformToGescom(payload) {
  const query = {
    code: payload.query.devisNum,
    montant: payload.query.montant,
    client: payload.query.pointDeVente,
    commercialEmail: payload.query.userId,
    societeId: payload.query.societeId,
    dateCreation: transformDate(payload.query.dateCreation),
    dateModification: transformDate(payload.query.dateModif),
    sens: devisConf.SENS_VENTE,
    etat: getEtatQuery(payload),
    pointDeVenteIds: payload.query.pointDeVenteIds ? payload.query.pointDeVenteIds : null,
    enseigneIds: payload.query.enseigneIds ? payload.query.enseigneIds : null,
    groupeIds: payload.query.groupeIds ? payload.query.groupeIds : null,
  }

  const orderTranslate = {
    dateModif: "LastModificationTime",
    dateCreation: "CreationTime",
    montant: "MontantTtc",
    devisNum: "Code",
  };

  if(orderTranslate[payload.orderBy]) {
    payload.orderBy = orderTranslate[payload.orderBy]
  }

  return {
    ...payload,
    query,
  }
}
